import BaseSelect from '@/components/base/BaseSelect';
import { LOCALES } from '@/constants';
import { useIntl, useSetLocale, type LocaleKey } from '@/i18n';
import { recordInterfaceLanguageSwitch } from '@/services/iam-admin';
import { useAuthStore } from '@/store/auth';
import { sessionRevision } from '@/utils/sessionLifecycle';
import { useRef, useState } from 'react';

/** 后台界面语言切换：繁體中文 / English。 */
export default function LanguageSelect() {
  const intl = useIntl();
  const setLocale = useSetLocale();
  const status = useAuthStore((state) => state.status);
  const inFlight = useRef(false);
  const [pending, setPending] = useState(false);

  /** 已登录切语必须留存审计；失败提示由统一请求出口处理。 */
  const changeLocale = async (value: LocaleKey) => {
    if (value === intl.locale || inFlight.current) return;
    if (status !== 'authed') {
      setLocale(value);
      return;
    }
    inFlight.current = true;
    setPending(true);
    const revision = sessionRevision();
    try {
      await recordInterfaceLanguageSwitch({
        from: intl.locale === 'en-US' ? 'en' : intl.locale,
        to: value === 'en-US' ? 'en' : value,
      });
      if (revision === sessionRevision()) setLocale(value);
    } catch {
      // 请求出口已显示错误，保留原语言使用户能够重试。
    } finally {
      inFlight.current = false;
      setPending(false);
    }
  };

  return (
    <BaseSelect<LocaleKey>
      className="admin-language-select w-36 shrink-0"
      aria-label={intl.formatMessage({ id: 'layout.language' })}
      value={intl.locale}
      options={LOCALES}
      loading={pending}
      allowClear={false}
      disabled={pending}
      onChange={(value) => {
        void changeLocale(value as LocaleKey);
      }}
    />
  );
}
